// extracted by mini-css-extract-plugin
export default {"dropdownTrigger":"dropdown-trigger_dropdownTrigger__HccUS","active":"dropdown-trigger_active__wAUJd","dropdownTriggerRtl":"dropdown-trigger_dropdownTriggerRtl__zPpMR"};